import React, { Component } from "react";
import { withPixiApp } from "@inlet/react-pixi";
 
import * as PIXI from "pixi.js";
import { connect } from "react-redux";
import { Dispatch } from "redux";


import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';

import "react-toggle/style.css";
import { relative } from "path";
import { isMobile } from "react-device-detect";
import withBetHistoryComponentConfiguration from "./configuration/withbetHistoryComponentConfiguration";


interface IProps {
    [x: string]: any;
}

interface IState {

}
interface IStore {
    [x: string]: any;
}
interface IState {
    [x: string]: any;

}

interface IStateToProps {
}

interface IDispatchToProps {
}

class BlockLayerUI extends Component<IProps, IState> {
    protected app: PIXI.Application;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
       
    }



    render() {
        if (!this.props.blockLayer) {
            return (<></>)
        }
        
        
        return (
            <div id={"BlockUI"}  style={{pointerEvents:"none"}}>
                 
            </div>
        )
    }
}


export default withPixiApp(connect(
    (state: Pick<IStore, 'behaviourState'>): IStateToProps =>
    ({

        blockLayer: state.behaviourState.blockLayer

    }),
    (dispatch: Dispatch): IDispatchToProps => ({

    }))(withBetHistoryComponentConfiguration(BlockLayerUI)));